import { z } from 'zod';

// EMV Tag Data on the payment wire - all fields optional as they vary by card/transaction
export const EmvDataSchema = z.object({
  // Core EMV Tags
  AID: z.string().optional(),              // Tag 9F06 - Application Identifier
  IAD: z.string().optional(),              // Tag 9F10 - Issuer Application Data
  TSI: z.string().optional(),              // Tag 9B - Transaction Status Information
  TVR: z.string().optional(),              // Tag 95 - Terminal Verification Results

  // Additional EMV Fields
  ARC: z.string().optional(),              // Tag 8A - Authorization Response Code
  'Application Label': z.string().optional(),      // Tag 50 - Application mnemonic
  'Application Preferred Name': z.string().optional(), // Tag 9F12 - Preferred mnemonic
  'Entry method': z.string().optional(),   // How card info was obtained
  Mode: z.string().optional(),             // Authorization mode (typically "Issuer")
  'Network Label': z.string().optional(),  // Authorizing network name for receipt
  PIN: z.string().optional(),              // Tag 9F34 - CVM Results (PIN status)
  Signature: z.string().optional(),        // Tag 9F34 - CVM Results (signature required)
}).loose(); // Allow additional EMV tags we might not know about

export const ReceiptDataSchema = z.object({
  address1: z.string().optional(),
  address2: z.string().optional(),
  dateTime: z.string().optional(),
  dba: z.string().optional(),
  footer: z.string().optional(),
  header: z.string().optional(),
  nameOnCard: z.string().optional(),
  phone: z.string().optional(),
});

// ReceiptObj includes receipt fields + EMV data + transaction response fields
export const ReceiptObjectDataSchema = ReceiptDataSchema.safeExtend({
  // EMV-related fields at root level (from emvTagData)
  Signature: z.string().optional(),
  Mode: z.string().optional(),
  'Network Label': z.string().optional(),
  'Entry method': z.string().optional(),
  'Application Label': z.string().optional(),
  'Application Preferred Name': z.string().optional(),
  PIN: z.string().optional(),

  // Nested EMV object with core tags
  emv: EmvDataSchema.optional(),

  // Transaction response fields (carried in receiptObj)
  respcode: z.string().optional(),  // Response code (e.g., "00", "000")
  respproc: z.string().optional(),  // Response processor (e.g., "BPAY", "RPCT")
  respstat: z.string().optional(),  // Response status (A/B/C)
  resptext: z.string().optional(),  // Response text (e.g., "Approved", "Approval")
  retref: z.string().optional(),    // Retrieval reference number
  token: z.string().optional(),     // Token/masked account number
}).loose(); // Allow additional merchant-specific fields

export type EmvDataType = z.infer<typeof EmvDataSchema>;
export type ReceiptDataType = z.infer<typeof ReceiptDataSchema>;
export type ReceiptObjectDataType = z.infer<typeof ReceiptObjectDataSchema>;
